import { logWarn } from '@ptek/client-logger';
import { useEffect } from 'react';
import { useWidgetContext } from './useWidgetContext';
export const useWidgetLifecycleHandlers = (config) => {
    const { registerLifecycleHandler } = useWidgetContext();
    useEffect(() => {
        if (!registerLifecycleHandler) {
            logWarn('useWidgetCloseHandler', 'Widget lifecycle handler registration not available');
            return;
        }
        const lifecycleHandler = (event) => {
            if (config.onLifecycleEvent) {
                return config.onLifecycleEvent(event);
            }
            switch (event) {
                case 'beforeUnmount':
                    return config.beforeUnmount?.() ?? true;
                case 'beforeHide':
                    return config.beforeHide?.() ?? true;
                default:
                    return true;
            }
        };
        registerLifecycleHandler(lifecycleHandler);
        return () => {
            registerLifecycleHandler(null);
        };
    }, [config, registerLifecycleHandler]);
};
export const useWidgetCloseHandler = (canUnmountCallback) => {
    return useWidgetLifecycleHandlers({
        beforeUnmount: canUnmountCallback,
    });
};
//# sourceMappingURL=useWidgetCloseHandler.js.map